/* global KJS */

/**
 * DX端末判定
 * @returns {boolean} DX端末か
 */
export function isDXTerminal() {
  try {
    // ライブラリが読み込まれていない場合はDX端末外
    if (
      typeof KJS === 'undefined' ||
      typeof KJS.DeviceInfo === 'undefined' ||
      !KJS.DeviceInfo.getLicenceInfo()
    ) {
      console.log('DX端末ではありません');
      return false;
    }

    // 998:非対応のユニット、999:ユニットID取得以外はDX端末
    const unitId = KJS.DeviceInfo.getUnitInfo();
    return unitId < 998;
  } catch (e) {
    return false;
  }
}

/**
 * Android端末か(isDXTerminalの後に判定)
 * @returns {boolean} Android端末か
 */
export function isAndroid() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent.indexOf('android') != -1) {
    return true;
  } else {
    return false;
  }
}

/**
 * 読み取り対象コード設定(バーコード)
 * @param {!object} codeTypes コード種
 * @returns {boolean} 設定成否
 */
export function scannerSetUseBarcode(codeTypes) {
  // 読み取り対象コード種の設定を取得する
  const param = KJS.Scanner.getConfig(KJS.Scanner.ConfigId.CodeType);
  if (!param) return false;

  // 設定値をすべて無効にする
  for (const key of Object.keys(param)) {
    param[key] = false;
  }

  // 対象バーコードを有効にする
  for (const typ of codeTypes) {
    if (typ !== codeType.OCR) param[typ] = true;
  }

  // 読み取り対象コード種の設定を設定する
  const ret = KJS.Scanner.setConfig(KJS.Scanner.ConfigId.CodeType, param);
  return ret === 0;
}

/**
 * 読み取り対象コード設定(OCR)
 * @returns {boolean} 設定成否
 */
export function scannerSetUseOcr() {
  // 読み取り対象コード種の設定を取得する
  const param = KJS.Scanner.getConfig(KJS.Scanner.ConfigId.CodeType);
  if (!param) return false;

  // 設定値をすべて無効にする
  for (const key of Object.keys(param)) {
    param[key] = false;
  }

  // OCRのみを有効にする
  param[codeType.OCR] = true;

  // 読み取り対象コード種の設定を設定する
  const ret = KJS.Scanner.setConfig(KJS.Scanner.ConfigId.CodeType, param);
  return ret === 0;
}

/**
 * 読取対象コードクリア
 * @returns {boolean} 設定成否
 */
export function scannerSetClear() {
  // 読み取り対象コード種の設定を取得する
  const param = KJS.Scanner.getConfig(KJS.Scanner.ConfigId.CodeType);
  if (!param) return false;

  // 設定値をすべて無効にする
  for (const key of Object.keys(param)) {
    param[key] = false;
  }

  // 読み取り対象コード種の設定を設定する
  const ret = KJS.Scanner.setConfig(KJS.Scanner.ConfigId.CodeType, param);
  return ret === 0;
}

/**
 * 読み取り結果の受け取り設定
 * @param {string} func コールバック関数名
 */
export function scannerSetReadCallback(func) {
  KJS.Scanner.setReadCallback(func);
}

/**
 * 読み取り結果の受け取り解除
 */
export function scannerClearReadCallback() {
  KJS.Scanner.clearReadCallback();
}

/**
 * 端末情報存在確認
 * @returns {boolean} true:存在、false:非存在
 */
export function fileExistsTermInfo() {
  if (isDXTerminal()) {
    // DX端末(Android)の場合
    return KJS.File.exists(0, 'FreeCheck/term_info.txt');
  } else {
    // その他(Chrome等)の場合
    return 'FreeCheck' in localStorage;
  }
}

/**
 * 端末情報取得
 * @returns {?object} 端末情報{termId,serverUrl,codeTypes}
 */
export async function fileGetTermInfo() {
  let termInfoText;
  if (isDXTerminal()) {
    // DX端末(Android)の場合
    const fileId = KJS.File.open(0, 'FreeCheck/term_info.txt');
    termInfoText = KJS.File.readLine(fileId);
    KJS.File.close(fileId);
  } else {
    // その他(Chrome等)の場合
    termInfoText = localStorage.getItem('FreeCheck');
  }

  // JSONオブジェクトを返す
  return JSON.parse(termInfoText);
}

/**
 * 端末情報設定
 * @param {object} info 端末情報{termId,serverUrl,codeTypes}
 */
export function setTerminalInfo(info) {
  // 端末情報ファイルに保存する
  if (isDXTerminal()) {
    // DX端末(Android)の場合はJS_FILE内のFreeCheck配下に保存
    if (!KJS.File.exists(0, 'FreeCheck')) KJS.File.createDirectory(0, 'FreeCheck');

    const filePath = 'FreeCheck/term_info.txt';
    if (!KJS.File.exists(0, filePath)) KJS.File.createFile(0, filePath);

    const fileId = KJS.File.open(0, filePath);
    KJS.File.write(fileId, JSON.stringify(info));
    KJS.File.close(fileId);
  } else {
    // その他(Chrome等)の場合はローカルストレージに保存
    localStorage.setItem('FreeCheck', JSON.stringify(info));
  }
}

export function deleteTerminalInfo() {
  return true;
}
